<app-report-runner
  reportType="outreach-contacts"
  title="Outreach Contacts Report"
  description="Number and type of outreach contacts during the selected period."
/>
